module.exports = __webpack_public_path__ + "img/usDetailBg.2cafd913.png";